export default "https://fiverr-res.cloudinary.com/npm-assets/@fiverr/search_perseus/life_coaching.4a8ba1a.svg";